import { useSearchParams } from 'next/navigation';

import type { SEARCH_PARAMS_TYPE } from '@/constants';
import { SEARCH_PARAMS } from '@/constants';

export const useEmergencyRoomParams = () => {
  const searchParams = useSearchParams();

  const emergencyRoomSearchParams = searchParams?.get(
    SEARCH_PARAMS.EMERGENCY_ROOM_PARAMS,
  );

  const emergencyRoomParams: SEARCH_PARAMS_TYPE.EMERGENCY_ROOM_PARAMS | null =
    emergencyRoomSearchParams ? JSON.parse(emergencyRoomSearchParams) : null;

  return emergencyRoomParams;
};
